import React from "react";
import { StatusBadge } from "../../ui";
import ControlEffectivenessBadge from "./ControlEffectivenessBadge";
import { useControlEffectivenessConfig } from "../../hooks/useControlEffectivenessConfig";
import Table from "../../ui/Table";
import { colors, spacing } from "../../ui/tokens";

const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "-");

const containerStyle = {
  border: "1px solid rgba(107, 114, 128, 0.25)",
  borderRadius: spacing.lg,
  overflow: "hidden",
  background: colors.background,
};

const headerStyle = {
  padding: spacing.lg,
  background: "rgba(107, 114, 128, 0.08)",
  borderBottom: "1px solid rgba(107, 114, 128, 0.2)",
};

export default function ControlTable({ controls, onRowClick, selectedId }) {
  const { items: effectivenessConfig } = useControlEffectivenessConfig();
  const columns = [
    { id: "name", header: "Name", accessor: "name" },
    {
      id: "description",
      header: "Description",
      accessor: (row) => row.description ?? "-",
    },
    {
      id: "status",
      header: "Status",
      accessor: (row) => <StatusBadge variant="status" value={row.status} fallbackLabel={row.status || "Unknown"} />,
    },
    {
      id: "effectiveness",
      header: "Effectiveness",
      accessor: (row) => <ControlEffectivenessBadge value={row.effectiveness_rating ?? row.effectiveness ?? ""} config={effectivenessConfig} />,
    },
    {
      id: "owner",
      header: "Owner",
      accessor: (row) => row.owner_id ?? "-",
    },
    {
      id: "framework",
      header: "Catalog ID",
      accessor: (row) => (row.catalog_id ? row.catalog_id : "-"),
    },
    {
      id: "category",
      header: "Category",
      accessor: (row) => row.category ?? "-",
    },
    {
      id: "updated",
      header: "Updated",
      accessor: (row) => formatDateTime(row.updated_at || row.created_at),
    },
  ];

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <strong>Controls</strong>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          columns={columns}
          data={controls}
          onRowClick={(row) => onRowClick && onRowClick(row)}
          getRowKey={(row) => row.id}
          getRowProps={(row) => ({
            style: row.id === selectedId ? { background: "rgba(37, 99, 235, 0.12)" } : undefined,
          })}
          emptyState="No controls found."
        />
      </div>
    </div>
  );
}
